import store from '../store';

const state = {
  cognitoInfo: {},
  loggedIn: false,
  loadingState: true,
  errorLoadingState: false,
};

function setLoggedIn(newValue) {
  state.loggedIn = newValue;
  store.dispatch('updateLoggedIn', newValue);
}

function setLoggedOut() {
  state.loggedIn = false;
  state.cognitoInfo = {};
  store.dispatch('updateLoggedIn', false);
  store.dispatch('updateCognitoInfo', {});
}

function setCognitoInfo(newValue) {
  state.cognitoInfo = newValue;
  store.dispatch('updateCognitoInfo',newValue);
}

export default {
  state,
  setLoggedIn,
  setLoggedOut,
  setCognitoInfo,
};
